module.exports = __webpack_public_path__ + "images/icon-description-0c2b42329ec579c1f1c999c182c1aec8.svg";